import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  findItems,
  initLostFound,
} from "../../../modules/reducers/lostFound/lostFound";
import lostFoundApi from "../api/lostFoundApi";
import { formatDateYYYYMMDD } from "../../../utils";
import useReactGASend from "../../../hooks/useReactGASend";
import { subMonths, startOfMonth } from "date-fns";

const useSearchItems = () => {
  const makeDate = () => {
    const currentDate = new Date(); // 현재 날짜와 시간을 얻습니다.
    const firstDayOfLastMonth = startOfMonth(subMonths(new Date(), 1));
    const firstDayOfCurrentMonth = startOfMonth(new Date());
    return { currentDate, firstDayOfLastMonth, firstDayOfCurrentMonth };
  };

  const dispatch = useDispatch();
  const { makeEventTrackFn } = useReactGASend();
  const { currentDate, firstDayOfLastMonth, firstDayOfCurrentMonth } =
    makeDate();
  const [formData, setFormData] = useState({
    branchName: "", // 점포 이름
    branchId: "", // 점포 번호
    startDay: firstDayOfCurrentMonth, // 습득 일자
    endDay: currentDate, // 습득 일자
    minDate: firstDayOfLastMonth,
    maxDate: currentDate,
    itemName: "", // 습득내역
  });

  const branchName = useSelector((state) => state.checkArsStatus.branchName);
  const branchId = useSelector((state) => state.checkArsStatus.branchId);
  const list = useSelector((state) => state.lostFound.list);
  const loaded = useSelector((state) => state.lostFound.loaded);

  useEffect(() => {
    dispatch(initLostFound());
  }, []);

  useEffect(() => {
    if (
      formData.startDay &&
      formData.endDay &&
      formData.startDay > formData.endDay
    ) {
      // 첫 번째 DatePicker의 날짜가 두 번째 DatePicker의 날짜보다 뒤인 경우 동기화
      setFormData((prevState) => ({
        ...prevState,
        endDay: formData.startDay,
      }));
    }
  }, [formData.startDay, formData.endDay]);

  useEffect(() => {
    if (branchName !== null && branchId !== null) {
      setFormData((prev) => ({
        ...prev,
        branchName,
        branchId,
      }));
    }
  }, [branchName, branchId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (date, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: date,
    }));
  };

  const search = () => {
    if (
      formData.startDay === (null || "") ||
      formData.endDay === (null || "")
    ) {
    } else {
      const api = lostFoundApi();
      const data = {
        store_code: formData.branchId,
        start_date: formData.startDay,
        end_date: formData.endDay,
        description: formData.itemName,
      };
      data.end_date = formatDateYYYYMMDD(formData.endDay);
      data.start_date = formatDateYYYYMMDD(formData.startDay);
      dispatch(
        findItems({
          ...api,
          data,
        })
      );
      makeEventTrackFn({
        category: "event",
        action: "습득물조회",
        body: { data_keyword: formData.itemName },
      });
    }
  };

  return {
    branchName,
    formData,
    handleChange,
    search,
    list,
    loaded,
    handleDateChange,
  };
};

export default useSearchItems;
